module.exports = __webpack_public_path__ + "static/media/2.448298e1.png";